import {Component, NgZone, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {NotificationService} from "../../../root/toast/notification.service";
import {ModalService} from "../../../root/modal/modal.service";
import {LoadingWheelService} from "../../../root/loading/loading-wheel.service";
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import {SessionService} from "../../../core/session.service";
import {SidebarService} from "../../../root/sidebar/sidebar.service";
import {PointOfSaleServiceA2} from "../point-of-sale.service";
import {PointOfSaleDto} from "../point-of-sale-dto";
import {GeoCodeService} from "../../../core/geo-code.service";
import {PointOfSaleValidatorService} from "./point-of-sale-validator.service";
import {PointOfSale} from "../point-of-sale";
import {BehaviorSubject, Observable} from "rxjs";
import {Subject} from "rxjs/Subject";
import {LoggerService} from "../../../core/logger.service";
import {TranslateService} from "@ngx-translate/core";
import {DestinationTypeEnum} from "../destination-type.enum";
import {GeoServiceA2} from "../../../core/geo_a2.service";
import {CityCodeEnum} from "../city-code.enum";
import {AirportCodeEnum} from "../airport-code.enum";

@Component({
    selector: 'point-of-sale-edit',
    templateUrl: './point-of-sale-edit.component.html',
    providers: [PointOfSaleServiceA2, GeoCodeService, PointOfSaleValidatorService]
})
export class PointOfSaleEditComponent implements OnInit{

    errors:any={};
    companyOid:number;
    countryCode:string='AR';
    id:string;
    isEditing:boolean = false;
    data:any={kms:[], paymentMethods:[], meetingType:[], phoneCode:'', days:[], hours:[]};
    endLoading:boolean=false;
    dto:PointOfSaleDto= new PointOfSaleDto();
    pointOfSaleForm:any;
    pointOfSale:PointOfSale;
    warningOn:boolean=false;
    countryId:number;
    subject:Subject<any>;
    enabledCountry:boolean = false;
    enabledCity:number;
    miamiCodeEnum:number = CityCodeEnum.MIAMI;
    isPointOfSale:boolean=true;

    // Utilizado para fixear la doble pasada por ngOnInit que produce inconsistencias en el display de los datos
    isFirstRun:boolean = true;

    errorMessages = {
        'posName': 'ERROR.pointOfSale.required',
        'posContact': 'ERROR.pointOfSale.required',
        'posPhone': 'ERROR.pointOfSale.required',
        'posKms': 'ERROR.pointOfSale.required',
        'posLocation': 'ERROR.pointOfSale.required',
        'posPaymentMethods': 'ERROR.pointOfSale.payment.required',
        'posBh': 'ERROR.pointOfSale.days.required',
    };

    constructor(private posService:PointOfSaleServiceA2,
                private  zone: NgZone, private route: ActivatedRoute,
                private toast:NotificationService, private navigation:Router, private modalService:ModalService,
                private loading:LoadingWheelService, private _fb: FormBuilder,
                private sidebar: SidebarService,
                private validator: PointOfSaleValidatorService, private sessionService:SessionService,
                private logger: LoggerService,
                private translate: TranslateService) {
    }

    ngOnInit(): void {
        if(this.isFirstRun) {
            this.isFirstRun = false;
            this.logger.info('PointOfSaleEditComponent: onInit');
            if(!this.dto.pickupIndications) {
                this.dto.pickupIndications = {meetingType:""};
            }

            this.subject = new BehaviorSubject(this.dto);

            if(this.isCountryInformationOnSession()) {
                this.countryId = JSON.parse(localStorage.getItem("company")).countryOid;
                this.countryCode = JSON.parse(localStorage.getItem("company")).countryCode;
                this.initDataView();
            } else {
                this.sessionService.getSubject().subscribe((message) => {
                    if(!!message.done){
                        this.logger.info('PointOfSaleEditComponent: session has finished loading, set data');
                        this.countryId = this.sessionService.getUserSession().countryOid;
                        this.countryCode = this.sessionService.getUserSession().countryCode;
                        this.initDataView();
                    }
                });
            }
        }
    }

    private isCountryInformationOnSession(): boolean {
        return !!JSON.parse(localStorage.getItem("company")).countryOid
            && !!JSON.parse(localStorage.getItem("company")).countryCode;
    }

    private initDataView() {
        this.zone.run(() => {
            this.sidebar.sidebar = "pointOfSale";
            this.loading.show();
            this.route.params.subscribe(params => {
                this.companyOid = params['companyId'];
                this.id = params['id'];
                this.isEditing = this.id ? this.id != "add" : false;
                this.posService.getData(this.companyOid, this.countryCode).subscribe((response) => {
                    this.logger.info('PointOfSaleEditComponent: retrieve metadata for view ok');
                    this.data = {
                        kms:response[0],
                        paymentMethods:response[3],
                        meetingType:response[2],
                        phoneCode:response[1],
                        days:this.posService.getDays().map((h) => {return {id:h, value:'common.week.'+h}}),
                        hours:this.posService.getHours().map((h) => {return {id:h, value:h}})
                    };
                    if (this.isEditing) {
                        this.posService.getOne(this.companyOid, this.id).subscribe(pos => {
                            this.logger.info(`PointOfSaleEditComponent: Success fetching pos: ${pos.oid}`);
                            this.modelPosView(pos);
                            this.endLoading = true;
                            this.loading.hide();
                        }, (error) => {this.logger.error('PointOfSaleEditComponent: fail fetching poss', error);throw(error);})
                    } else {
                        this.endLoading = true;
                        this.loading.hide();
                    }
                    this.loading.hide();
                    this.bindValidations();
                    this.enabledCity = JSON.parse(localStorage.getItem("company")).cityOid;
                    }, (error) => {this.logger.error('PointOfSaleEditComponent: fail retrieving metadata', error);throw(error);});
             });
        });
    }

    private bindValidations() {
        this.pointOfSaleForm = this._fb.group({
            posName: ['', Validators.required],
            posContact: ['', Validators.required],
            posPhone: ['', Validators.required],
            // street: ['', Validators.required],
            posPaymentMethods: ['', this.validator.validatePaymentMethods],
            posKms: ['', (c: FormControl)=>!!c.value? null:{valid: false}],
            posBh: ['', Validators.required],
            posLocation: ['', this.validator.validateLocation],
            posMeetingType: ['', this.validator.validateMeetingType],
            posPickupIndications:  ['', this.validator.validatePickupIndications],
        });
    }

    private bindValues() {
        this.pointOfSaleForm.controls['posName'].setValue(this.dto.name);
        this.pointOfSaleForm.controls['posContact'].setValue(this.dto.contact);
        this.pointOfSaleForm.controls['posPhone'].setValue(this.dto.phone);
        // se definen bajo un solo formControl para validar en el front pero el DTO que se envía al servidor
        // mantiene propiedades separadas para los medios de pago permitidos (tarjetas y/o pago en destino)
        this.pointOfSaleForm.controls['posPaymentMethods'].setValue({
            paymentMethods: this.dto.paymentMethods,
            payInCash: this.dto.payInCash
        });
        this.pointOfSaleForm.controls['posKms'].setValue(this.dto.kms);
        this.pointOfSaleForm.controls['posBh'].setValue(this.dto.businessHours);
        this.pointOfSaleForm.controls['posLocation'].setValue({destination:this.dto.locationName,
            destinationType:this.dto.destinationType, street:this.dto.street});
        this.pointOfSaleForm.controls['posMeetingType'].setValue({meetingType: this.dto.pickupIndications.meetingType,
            destinationType:this.dto.destinationType, enabledCountry: this.enabledCountry, street:this.dto.street});
        this.pointOfSaleForm.controls['posPickupIndications'].setValue(this.bindPickupIndications());}

    private bindPickupIndications() {
        return { meetingType: this.dto.pickupIndications.meetingType,
                enabledCountry: this.enabledCountry,
                additionalInstructions:this.dto.pickupIndications.additionalInstructions };
       }

    save(){
        let pos = this.buildModel(this.dto);
        this.errors = [];
        this.bindValues();
        let validations = this.validator.validate(this.pointOfSaleForm);
        if(validations.valid){
            this.zone.run(() => {
                if(!this.isEditing){
                    this.logger.info(`PointOfSaleEditComponent: Saving pos ${JSON.stringify(pos)}`);
                    this.posService.save(pos,this.companyOid).subscribe((response) => {
                        this.persistCallback();
                    }, (error) => {this.logger.error('PointOfSaleEditComponent: fail saving', error);throw(error);});
                }else{
                    this.logger.info(`PointOfSaleEditComponent: Updating pos ${JSON.stringify(pos)}`);
                    // pos.pickupIndications = {};
                    this.posService.update(pos,this.companyOid,this.id).subscribe((response) => {
                        this.persistCallback();
                    }, (error) => {this.logger.error('PointOfSaleEditComponent: fail updating', error);
                    throw(error);});
                }
            })
        }else{
            this.logger.info(`PointOfSaleEditComponent: Validation error on persitance ${validations.errors}`);
            this.errors = validations.errors;
            this.toast.notifyErrorByCode('ERROR.required.fields');
        }
    }

    private persistCallback(){
        this.logger.info(`PointOfSaleEditComponent: Persistance Ok, back to list`);
        this.toast.displayToast('pointOfSale.TITLE','pointOfSale.confirmationMessage.SUCCESS_SAVE', null, 'INFO');
        this.navigation.navigateByUrl('/company/'+this.companyOid+'/pointOfSale');
    }

    private buildModel(dto: PointOfSaleDto) : PointOfSale {
        return {
            name:dto.name,
            locationOid:dto.locationOid,
            locationName:dto.locationName,
            geoLocation:dto.geoLocation,
            street:dto.street,
            phone:dto.phone,
            contactName:dto.contact,
            email:dto.email,
            companyOid:this.companyOid,
            distanceUnit:dto.kms,
            businessHours:dto.businessHours,
            paymentOptions:Object.keys(dto.paymentMethods)
                .filter(key => dto.paymentMethods[key])
                .map((k) => { return {code:k}; }),
            payInCashAvailable:dto.payInCash,
            destinationType:dto.destinationType,
            pickupIndications:this.buildPickupIndications(dto),
            specialAttentionHours:dto.specialAttentionHours
        }
    }

    private buildPickupIndications(dto) {
        if(this.hasPickupIndications(dto.destinationType)){
            return {
                meetingType: dto.pickupIndications.meetingType,
                additionalInstructions:dto.pickupIndications.additionalInstructions
            }
        }
        return { meetingType: dto.pickupIndications.meetingType }
    }

    hasPickupIndications(destinationType: string): boolean {
        return destinationType === DestinationTypeEnum.AIRPORT
    }

    cancel() {
        this.modalService.show("CANCEL_ALERT_TITLE", "CANCEL_ALERT_DESCRIPTION",
            () => this.navigation.navigateByUrl(`/company/${this.companyOid}/pointOfSale`));
    }

    setWarning() {
        this.warningOn = true;
        setTimeout(function () {
            this.warningOn = false;
        }, 6000);
    }

    private modelPosView(pos: any) {
        this.dto = {
            name:pos.name,
            contact:pos.contactName,
            phone:pos.phone,
            email:pos.email,
            destinationType:pos.destinationType,
            destinationTypeValue: this.translate.instant("pointOfSale.destinationType." + pos.destinationType),
            kms:pos.distanceUnit === "UNLIMITED"?"UNLIMITED":'KM_' + pos.distanceMax,
            businessHours:pos.businessHours.map(bh => {return {closingHour:bh.closingHour,dayOfWeek:bh.dayOfWeek,openingHour:bh.openingHour,
                additionalOpeningHour:bh.additionalOpeningHour,additionalClosingHour:bh.additionalClosingHour}}),
            specialAttentionHours:pos.specialAttentionHours,
            paymentMethods:{},
            payInCash:!!pos.payInCashAvailable,
            street:pos.street,
            locationName:pos.locationName,
            locationOid:pos.locationOid,
            geoLocation:pos.geoLocation,
            days:{},
            pickupIndications:!pos.pickupIndications?{meetingType:""} :{
                meetingType:pos.pickupIndications.meetingType,
                additionalInstructions:pos.pickupIndications.additionalInstructions
            }
        };

        if(this.dto.pickupIndications && this.isEditing && this.isSpecialAirport(this.dto.locationOid) && this.dto.pickupIndications.meetingType !== "COUNTER"){
            this.dto.pickupIndications.meetingType = "";
            this.dto.pickupIndications.additionalInstructions = "";
        }

        pos.paymentOptions.forEach(pm => this.dto.paymentMethods[pm.code] = true);
        this.subject.next(this.dto);
    }

    private isSpecialAirport(locationOid):boolean {
        return locationOid == AirportCodeEnum.MIAMI_AIRPORT ||
            locationOid == AirportCodeEnum.CANCUN_AIRPORT ||
            locationOid == AirportCodeEnum.ORLANDO_AIRPORT;
    }

    goToAdditionals(){
        this.navigation.navigateByUrl('/company/'+this.companyOid+'/pickupPoint');
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/feature/pointOfSale/edit/point-of-sale-edit.component.ts